import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { fmtDate } from "@/lib/checkins";

const WINDOWS = [["today", "Due today"], ["week", "Next 7 days"], ["overdue", "Overdue"]];

export function DuePanel() {
  const [w, setW] = useState("week");
  const [rows, setRows] = useState(null);
  useEffect(() => {
    setRows(null);
    api.get("/checkin-due", { params: { window: w } }).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [w]);
  return (
    <div className="space-y-3" data-testid="checkin-due">
      <div className="flex gap-2">
        {WINDOWS.map(([k, l]) => <Button key={k} size="sm" variant={w === k ? "default" : "outline"} onClick={() => setW(k)} data-testid={`due-window-${k}`}>{l}</Button>)}
      </div>
      {!rows ? <Loader2 className="h-5 w-5 animate-spin text-zinc-400" /> : rows.length === 0 ? (
        <p className="text-sm text-zinc-600" data-testid="due-empty">No progress reviews in this window.</p>
      ) : (
        <table className="w-full text-sm">
          <thead><tr className="text-left text-2xs uppercase tracking-[0.15em] text-zinc-500"><th className="py-1">Client</th><th>Template</th><th>Next due</th><th>Open progress review</th><th>Practitioner</th></tr></thead>
          <tbody className="divide-y divide-zinc-100">
            {rows.map((e) => (
              <tr key={e.id} data-testid={`due-row-${e.id}`}>
                <td className="py-2"><Link className="text-sky-800 hover:underline" to={`/clients/${encodeURIComponent(e.client_email)}?tab=checkins`}>{e.client_name}</Link></td>
                <td>{e.template_name}</td>
                <td className="font-mono-num">{fmtDate(e.next_due_at)}</td>
                <td>{e.open_invitation ? `${e.open_invitation.status} · due ${fmtDate(e.open_invitation.due_date)}` : "—"}</td>
                <td>{e.practitioner_name || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
